<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
};
</script>
<style lang="scss">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #333333;
}
//自定义进度条颜色
#nprogress {
  .bar {
    background: #41b883 !important;
    .peg {
      box-shadow: 0 0 10px #41b883, 0 0 5px #41b88386;
    }
  }
  .spinner .spinner-icon {
    border-top-color: #41b883;
    border-left-color: #41b883;
  }
}
/* 解决element-ui的table表格控件表头与内容列不对齐问题 */
body .el-table th.gutter {
  display: table-cell !important;
}
</style>
